/**
 * Combined OAuth scopes for Atlassian integrations (Jira + Confluence).
 * Used by Nango when initiating the OAuth flow so a single Atlassian connection
 * grants access to both Jira issues and Confluence pages.
 *
 * Jira scopes:
 *  - read:jira-work / write:jira-work — read and write Jira issues
 *  - manage:jira-project / manage:jira-configuration — project and configuration management
 *  - read:jira-user — user lookup
 *
 * Confluence scopes:
 *  - read:confluence-content.summary / read:confluence-content.all — page content access
 *  - read:confluence-space.summary — space metadata
 *  - read:confluence-props — content properties
 *  - read:confluence-user — user profiles
 *  - read:confluence-groups — group membership
 *  - search:confluence — search across spaces and pages
 *  - read:page:confluence — view page content
 *  - read:space:confluence — view space details
 *
 * General:
 *  - offline_access — long-lived refresh tokens
 */
export const ATLASSIAN_FULL_SCOPES = [
  'read:jira-work',
  'manage:jira-project',
  'manage:jira-configuration',
  'read:jira-user',
  'write:jira-work',
  'offline_access',
  'read:confluence-content.summary',
  'search:confluence',
  'read:confluence-space.summary',
  'read:confluence-props',
  'read:confluence-content.all',
  'read:confluence-user',
  'read:confluence-groups',
  'read:page:confluence',
  'read:space:confluence',
].join(' ');
